<template>
    <div class="g-remove-check-code background-cover">
        <div class="display-flex">
            <p class="g-remove-check-code_title">已向员工{{ maskUserName }}预留手机号{{ maskMobilePhone }}发送验证码</p>
            <span>
            <el-tooltip placement="top" class="g-remove-check-code_title ml-1">
            <div slot="content">
                手机号不正确?请联系管理员处理
            </div>
                <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"/>
            </el-tooltip>
        </span>
        </div>
        <div class="g-remove-check-code_content"
             @keydown="fnCheckCodeKeydown"
             @paste="fnCheckCodeKeyPaste"
             @input="fnCheckCodeInputEvent"
        >
            <b-form-input :class="{'g-code-input_color': aCheckCodeInputComputed[0] !== ''}" autofocus max="9"
                   min="0" maxlength="1"
                   data-index="0" v-model.trim.number="aCheckCodeInputComputed[0]" type="number"  ref="firstInputRef"/>
            <b-form-input  :class="{'g-code-input_color': aCheckCodeInputComputed[1] !== ''}" max="9" min="0" maxlength="1"
                   data-index="1" v-model.trim.number="aCheckCodeInputComputed[1]" type="number"/>
            <b-form-input  :class="{'g-code-input_color': aCheckCodeInputComputed[2] !== ''}" max="9" min="0" maxlength="1"
                   data-index="2" v-model.trim.number="aCheckCodeInputComputed[2]" type="number"/>
            <b-form-input  :class="{'g-code-input_color': aCheckCodeInputComputed[3] !== ''}" max="9" min="0" maxlength="1"
                   data-index="3" v-model.trim.number="aCheckCodeInputComputed[3]" type="number"/>
            <b-form-input  :class="{'g-code-input_color': aCheckCodeInputComputed[4] !== ''}" max="9" min="0" maxlength="1"
                   data-index="4" v-model.trim.number="aCheckCodeInputComputed[4]" type="number"/>
            <b-form-input  :class="{'g-code-input_color': aCheckCodeInputComputed[5] !== ''}" max="9" min="0" maxlength="1"
                   data-index="5" v-model.trim.number="aCheckCodeInputComputed[5]" type="number"  ref="lastInputRef"/>
        </div>
        <div class="g-remove-check-code_tip display-col-flex">
            <p>请输入六位数验证码</p>
            <span v-if="showErrorMsg" class="text-danger">{{ errorMessage }}</span>
            <el-button type="primary" :disabled="countdown > 0" @click="sendVerifyCode">
                {{ countdown > 0 ? countdown + '秒' + '后可重新发送验证码' : '发送验证码' }}
            </el-button>
        </div>

    </div>
</template>

<script>
import emLoginMixin from "@/mixin/em/common/stuffs/login/emLoginMixin";

export default {
    props: {
        loginForm: {}
    },
    mixins: [emLoginMixin],
    data() {
        return {
            requestForm: {},
            smsRequestForm: {
                mobilePhone: '',
                businessType: '',
            },
            smsCode: '', //拼接的验证码内容
            aCheckCodeInput: ['', '', '', '', '', ''], 	// 存储输入验证码内容
            aCheckCodePasteResult: [], 				// 粘贴的验证码
            errorMessage: '', //错误代码
            showErrorMsg: false,
            mobilePhone: '',
            maskMobilePhone: '',
            maskUserName: '',
            countdown: 0,
            timer: null,
        }
    },
    computed: {
        // 验证码计算属性
        aCheckCodeInputComputed() {
            if (this.aCheckCodePasteResult.length === 6) {
                return this.aCheckCodePasteResult;
            } else if (this.aCheckCodeInput && Array.isArray(this.aCheckCodeInput) && this.aCheckCodeInput.length === 6) {
                return this.aCheckCodeInput;
            } else if (/^\d{6}$/.test(this.aCheckCodeInput.toString())) {
                return this.aCheckCodeInput.toString().split("");
            } else {
                return new Array(6);
            }
        },
        // 检测验证码是否输入完整
        bCheckCodeInputComplete() {
            return this.aCheckCodeInput.some(item => item === '');
        }
    },
    //监听验证码长度，如果为六位自动调用验证码登录接口
    watch: {
        countdown: {
            handler(newVal) {
                this.countdown = newVal
            }
        },
        aCheckCodeInputComputed() {
            let tempValue = '';
            for (let i = 0; i < this.aCheckCodeInputComputed.length; i++) {
                tempValue = tempValue + this.aCheckCodeInputComputed[i];
            }
            this.smsCode = tempValue;
        },
        smsCode(newValue) {
            if (newValue.length === 6) {
                this.$set(this.requestForm, 'verifyCode', this.smsCode);
                this.errorMessage = '';
                this.showErrorMsg = false;
                //验证短信验证码并登录
                this.$store.dispatch("api/post", {
                    url: this.$store.state.emAclUser.baseModuleUrl + "/sso/checkVerifyCodeAndLogin",
                    data: this.requestForm,
                }).then((response) => {
                    const data = response.data
                    if (data) {
                        if (data.code !== 200) {
                            this.showErrorMsg = true;
                            this.errorMessage = data.message;
                            this.$refs.lastInputRef.focus();
                        } else {
                            this.recordLoginInfoAndRedirect(data)
                        }
                    }
                })
                //成功返回jwt,失败清空smsCode 二维码界面提示
            }
        },
    },
    mounted() {
        this.requestForm = this.loginForm;
        this.mobilePhone = this.loginForm.mobilePhone;
        //脱敏处理
        let regular = /(\d{3})\d*(\d{4})/;
        this.maskMobilePhone = this.mobilePhone.replace(regular, '$1****$2');
        this.maskUserName = this.hideName(this.loginForm.userRealName);
        this.startCountdown();
    },
    methods: {
        sendVerifyCode() {
            this.errorMessage = '';
            this.showErrorMsg = false;
            this.smsRequestForm.mobilePhone = this.requestForm.mobilePhone;
            this.smsRequestForm.businessType = this.requestForm.businessType;
            this.$store.dispatch("api/post", {
                url: this.$store.state.emAclUser.baseModuleUrl + "/sso/sendVerifyCode",
                data: this.smsRequestForm,
            }).then((response) => {
                const data = response.data
                if (data) {
                    if (data.code !== 200) {
                        this.errorMessage = data.message;
                        this.showErrorMsg = true;
                    } else {
                        this.startCountdown();
                    }
                }
            })
        },
        // 输入验证码，检测位置变化
        fnCheckCodeKeydown(e) {
            let index = e.target.dataset.index * 1;
            let el = e.target;
            if (e.key === 'Enter') {
                if (this.bCheckCodeInputComplete) {
                    this.$message.warning('请输入六位数验证码~');
                    return;
                }
                // 执行请求接口方法
                return;
            }
            if (e.key === "Backspace") {
                this.aCheckCodeInput.splice(index, 1, '');
                if (el.previousElementSibling) {
                    el.previousElementSibling.focus();
                }
                e.preventDefault();
            } else if (e.key === "Home") {
                el.parentElement.children[0] && el.parentElement.children[0].focus();
            } else if (e.key === "End") {
                el.parentElement.children[this.aCheckCodeInput.length - 1] &&
                el.parentElement.children[this.aCheckCodeInput.length - 1].focus();
            } else if (e.key === "ArrowLeft") {
                if (el.previousElementSibling) el.previousElementSibling.focus();
            } else if (e.key === "ArrowRight") {
                if (el.nextElementSibling) el.nextElementSibling.focus();
            }
        },
        // 输入验证码，解决一个输入框输入多个字符的问题
        fnCheckCodeInputEvent(e) {
            let index = e.target.dataset.index * 1;
            let el = e.target;
            el.value = el.value
                    .replace(/Digit|Numpad/i, "")
                    .slice(0, 1);
            this.aCheckCodeInput[index] = el.value;
            if (e.key === 'Enter') return;
            if (/^[0-9]*$/.test(el.value)) {
                // 必须在这里赋值，否则输入框会是空值
                el.nextElementSibling && el.nextElementSibling.focus();
                if (index === 5) {
                    if (this.aCheckCodeInput.join("").length === 6) document.activeElement.blur();
                }
            }
        },
        // 验证码粘贴
        fnCheckCodeKeyPaste(e) {
            e.clipboardData.items[0].getAsString((str) => {
                if (str.toString().length === 6) {
                    this.aCheckCodePasteResult = str.split("");
                    document.activeElement.blur();
                    this.aCheckCodeInput = this.aCheckCodeInputComputed;
                    this.aCheckCodePasteResult = [];
                } else {
                    // 如果粘贴内容不合规，清除所有内容
                    this.aCheckCodeInput = ['', '', '', '', '', ''];
                }
            });
        },
        startCountdown() {
            this.countdown = 59;
            this.timer = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--;
                } else {
                    clearInterval(this.timer);
                    this.timer = null;
                }
            }, 1000);
        },
        hideName(name) {
            if (name && name !== '') {
                if (name.length === 2) {
                    name = name.substring(0, 1) + '*'
                }
                if (name.length > 2) {
                    name = name.substring(0, 1) + '*' + name.charAt(name.length - 1)
                }
                return name
            } else {
                return name
            }
        }
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    },
}
</script>
<style>
.g-remove-check-code {
    width: 100%;
    padding: 4px 0 8px 0;
}

.display-flex {
    display: flex;
}

.display-col-flex {
    display: flex;
    flex-direction: column;
}

.g-remove-check-code .g-remove-check-code_title {
    font-size: 14px;
    color: #666;
}

.g-remove-check-code .g-remove-check-code_content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 400px;
    padding: 28px 0 28px 0;
    margin: 0 auto;
}

.g-remove-check-code .g-remove-check-code_content input {
    width: 50px;
    height: 50px;
    font-size: 36px;
    text-align: center;
    border: none;
    outline: none;
    border: solid 1px rgba(187, 187, 187, 100);
    border-radius: 4px;
    -moz-appearance: textfield;
}

.g-remove-check-code .g-remove-check-code_content input.g-code-input_color {
    border-color: #5290FF;
}

.g-remove-check-code .g-remove-check-code_content input::-webkit-outer-spin-button,
.g-remove-check-code .g-remove-check-code_content input::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
}

.g-remove-check-code .g-remove-check-code_tip {
    font-size: 14px;
    color: #999;
    text-align: center;
}

.background-cover {
    z-index: 6099 !important;
}
</style>
